import {
  fetchWebDeleteFavorites,
  TWebDeleteFavoritesRequest,
  TWebDeleteFavoritesResponse,
} from '../repositories/favorites/v1/web/delete-favorites';
import { IThunkContext } from '../types/redux';

export const deleteAllFavorites = (context: IThunkContext, parameters: TWebDeleteFavoritesRequest) => {
  const { httpApi, logger } = context;

  return fetchWebDeleteFavorites({ httpApi, parameters })
    .then((response: TWebDeleteFavoritesResponse) => {
      if (response.statusCode !== 200) {
        return null;
      }

      const { statusCode } = response;

      return {
        statusCode,
      };
    })
    .catch(error => {
      logger.error(error, {
        domain: 'fetchDesktopGetUserFavorites',
        details: {
          repository: 'frontend-favorites',
          service: 'favorites',
        },
      });

      throw new Error(error);
    });
};
